import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

// tslint:disable:max-line-length
class ErrorX extends React.Component<{style?: {[key: string]: any}, active?: boolean }> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { active, style } = this.props;

    return (
      <svg height={35} width={35} viewBox='0 0 18 18' enable-background='new 0 0 18 18' style={{...style}}>
        <g id='layer1' transform='translate(-158.85715,-405.50504)'>
          <path fill={style && style.color ? style.color : active ? colors.red : colors.primary}  id='text2160' d='M176.068,407.132l0.375,0.551c-0.033,0.134-0.117,0.283-0.251,0.45c-0.067,0.05-0.101,0.101-0.101,0.151
		c0,0.016,0.017,0.058,0.05,0.125c-2.153,2.17-3.979,4.206-5.482,6.108c2.02,2.671,3.254,4.2,3.705,4.582
		c-0.084,0.468-0.267,0.827-0.551,1.077c-0.1,0.084-0.225,0.183-0.376,0.3c-0.266,0.219-0.399,0.335-0.399,0.353v0.023l0.075,0.275
		c-0.068,0.033-0.127,0.092-0.176,0.175c-0.184,0.218-0.385,0.369-0.601,0.452c-0.067,0-0.15-0.05-0.252-0.151
		c-0.066-0.048-0.149-0.108-0.249-0.175c-0.101-0.067-0.149-0.101-0.149-0.101c-0.018-0.016-0.034-0.025-0.051-0.025
		c0,0-0.026,0.018-0.076,0.051c-0.35,0.435-0.667,0.71-0.951,0.827c-0.05,0-0.117-0.025-0.2-0.076
		c-0.534-0.549-1.101-1.268-1.702-2.152c-0.5-0.751-0.875-1.287-1.127-1.604l-0.249,0.35l-1.728,2.255
		c-0.217,0.284-0.834,1.136-1.853,2.553h-0.326l-0.477-0.524c0.034-0.134,0.052-0.201,0.052-0.201
		c0.033-0.1,0.049-0.149,0.049-0.149c0-0.1-0.05-0.151-0.15-0.151s-0.25,0.052-0.45,0.151c-0.018,0-0.067,0.024-0.15,0.075
		c-0.184-0.101-0.451-0.435-0.802-1.001c-0.1-0.149-0.149-0.251-0.149-0.301c0-0.033,0.042-0.109,0.125-0.226
		c0.117-0.185,0.175-0.334,0.175-0.45c0-0.033-0.083-0.228-0.25-0.576c-0.083-0.251-0.124-0.375-0.124-0.375l1.226-1.578
		l2.729-3.153c0.067-0.102,0.134-0.185,0.2-0.251c-1.084-1.886-1.968-3.755-2.653-5.609c-0.15-0.451-0.241-0.768-0.275-0.951
		c0.234-0.367,0.542-0.736,0.927-1.103c0.167,0.134,0.291,0.235,0.375,0.301c0.066,0.117,0.133,0.175,0.2,0.175
		c0.167,0,0.275-0.124,0.325-0.375c0.051-0.468,0.259-0.71,0.627-0.726c0.117,0,0.275,0.108,0.475,0.324
		c1.053,1.72,2.063,3.247,3.029,4.583c2.172-2.387,3.964-4.231,5.384-5.534c0.284-0.25,0.441-0.375,0.476-0.375
		c0.083,0,0.334,0.208,0.752,0.625l0.149,0.201c0,0.033-0.025,0.091-0.075,0.176c-0.033,0.033-0.049,0.066-0.049,0.099
		c0,0.05,0.149,0.184,0.448,0.402l0.377-0.1L176.068,407.132z'/>
</g>
      </svg>
    );
  }
}

export default ErrorX;



// WEBPACK FOOTER //
// ./src/modules/svgs/error_x/index.web.tsx